// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__gANhr","text":"Loader_text__38_XU","content":"Loader_content__AmjD3","span":"Loader_span__tkZj3","loaderSpan":"Loader_loaderSpan__XHEu2"};